export const INVITE_CODE = 'ic';
